import "core-js/modules/esnext.string.replace-all.js";
import { __spreadArray as e, __assign as t } from "tslib";
import n from "@emotion/is-prop-valid";
import o, { useRef as r, useState as s, useMemo as i, useEffect as a, useContext as c, useDebugValue as l, createElement as u } from "react";
import p from "shallowequal";
import * as d from "stylis";
import h from "@emotion/unitless";
var f = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  m = "6.0.8",
  y = "undefined" != typeof window && "HTMLElement" in window,
  v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV),
  g = {},
  S = /invalid hook call/i,
  w = new Set(),
  b = function (t, n) {
    if ("production" !== process.env.NODE_ENV) {
      var o = n ? ' with the id of "'.concat(n, '"') : "",
        s = "The component ".concat(t).concat(o, " has been created dynamically.\n") + "You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",
        i = console.error;
      try {
        var a = !0;
        console.error = function (t) {
          for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
          S.test(t) ? (a = !1, w.delete(s)) : i.apply(void 0, e([t], n, !1));
        }, r(), a && !w.has(s) && (console.warn(s), w.add(s));
      } catch (e) {
        S.test(e.message) && w.delete(s);
      } finally {
        console.error = i;
      }
    }
  },
  E = Object.freeze([]),
  N = Object.freeze({});
function P(e, t, n) {
  return void 0 === n && (n = N), e.theme !== n.theme && e.theme || t || n.theme;
}
var _ = new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]),
  C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  I = /(^-|-$)/g;
function A(e) {
  return e.replace(C, "-").replace(I, "");
}
var O = /(a)(d)/gi,
  D = function (e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function R(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = D(t % 52) + n;
  return (D(t % 52) + n).replace(O, "$1-$2");
}
var T,
  k = function (e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  j = function (e) {
    return k(5381, e);
  };
function x(e) {
  return R(j(e) >>> 0);
}
function V(e) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function F(e) {
  return "string" == typeof e && ("production" === process.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var M = "function" == typeof Symbol && Symbol.for,
  $ = M ? Symbol.for("react.memo") : 60115,
  z = M ? Symbol.for("react.forward_ref") : 60112,
  B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  Y = ((T = {})[z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, T[$] = G, T);
function W(e) {
  return ("type" in (t = e) && t.type.$$typeof) === $ ? G : "$$typeof" in e ? Y[e.$$typeof] : B;
  var t;
}
var q = Object.defineProperty,
  H = Object.getOwnPropertyNames,
  U = Object.getOwnPropertySymbols,
  J = Object.getOwnPropertyDescriptor,
  X = Object.getPrototypeOf,
  Z = Object.prototype;
function K(e, t, n) {
  if ("string" != typeof t) {
    if (Z) {
      var o = X(t);
      o && o !== Z && K(e, o, n);
    }
    var r = H(t);
    U && (r = r.concat(U(t)));
    for (var s = W(e), i = W(t), a = 0; a < r.length; ++a) {
      var c = r[a];
      if (!(c in L || n && n[c] || i && c in i || s && c in s)) {
        var l = J(t, c);
        try {
          q(e, c, l);
        } catch (e) {}
      }
    }
  }
  return e;
}
function Q(e) {
  return "function" == typeof e;
}
function ee(e) {
  return "object" == typeof e && "styledComponentId" in e;
}
function te(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function ne(e, t) {
  if (0 === e.length) return "";
  for (var n = e[0], o = 1; o < e.length; o++) n += t ? t + e[o] : e[o];
  return n;
}
function oe(e) {
  return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function re(e, t, n) {
  if (void 0 === n && (n = !1), !n && !oe(e) && !Array.isArray(e)) return t;
  if (Array.isArray(t)) for (var o = 0; o < t.length; o++) e[o] = re(e[o], t[o]);else if (oe(t)) for (var o in t) e[o] = re(e[o], t[o]);
  return e;
}
function se(e, t) {
  Object.defineProperty(e, "toString", {
    value: t
  });
}
var ie = "production" !== process.env.NODE_ENV ? {
  1: "Cannot create styled-component for component: %s.\n\n",
  2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
  9: "Missing document `<head>`\n\n",
  10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
  14: 'ThemeProvider: "theme" prop is required.\n\n',
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
  17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",
  18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"
} : {};
function ae() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  for (var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1) o.push(e[r]);
  return o.forEach(function (e) {
    n = n.replace(/%[a-z]/, e);
  }), n;
}
function ce(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
  return "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(ae.apply(void 0, e([ie[t]], n, !1)).trim());
}
var le = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, e.prototype.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, o = n.length, r = o; e >= r;) if ((r <<= 1) < 0) throw ce(16, "".concat(e));
        this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
        for (var s = o; s < r; s++) this.groupSizes[s] = 0;
      }
      for (var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++) this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          o = n + t;
        this.groupSizes[e] = 0;
        for (var r = n; r < o; r++) this.tag.deleteRule(n);
      }
    }, e.prototype.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++) t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
      return t;
    }, e;
  }(),
  ue = new Map(),
  pe = new Map(),
  de = 1,
  he = function (e) {
    if (ue.has(e)) return ue.get(e);
    for (; pe.has(de);) de++;
    var t = de++;
    if ("production" !== process.env.NODE_ENV && ((0 | t) < 0 || t > 1073741824)) throw ce(16, "".concat(t));
    return ue.set(e, t), pe.set(t, e), t;
  },
  fe = function (e, t) {
    ue.set(e, t), pe.set(t, e);
  },
  me = "style[".concat(f, "][").concat("data-styled-version", '="').concat("6.0.8", '"]'),
  ye = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),
  ve = function (e, t, n) {
    for (var o, r = n.split(","), s = 0, i = r.length; s < i; s++) (o = r[s]) && e.registerName(t, o);
  },
  ge = function (e, t) {
    for (var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++) {
      var a = o[s].trim();
      if (a) {
        var c = a.match(ye);
        if (c) {
          var l = 0 | parseInt(c[1], 10),
            u = c[2];
          0 !== l && (fe(u, l), ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
        } else r.push(a);
      }
    }
  };
function Se() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var we = function (e) {
    var t = document.head,
      n = e || t,
      o = document.createElement("style"),
      r = function (e) {
        var t = Array.from(e.querySelectorAll("style[".concat(f, "]")));
        return t[t.length - 1];
      }(n),
      s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute(f, "active"), o.setAttribute("data-styled-version", "6.0.8");
    var i = Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
  },
  be = function () {
    function e(e) {
      this.element = we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, o = t.length; n < o; n++) {
          var r = t[n];
          if (r.ownerNode === e) return r;
        }
        throw ce(17);
      }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, e.prototype.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return t && t.cssText ? t.cssText : "";
    }, e;
  }(),
  Ee = function () {
    function e(e) {
      this.element = we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t);
        return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
      }
      return !1;
    }, e.prototype.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  Ne = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  Pe = y,
  _e = {
    isServer: !y,
    useCSSOMInjection: !v
  },
  Ce = function () {
    function e(e, n, o) {
      void 0 === e && (e = N), void 0 === n && (n = {});
      var r = this;
      this.options = t(t({}, _e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && y && Pe && (Pe = !1, function (e) {
        for (var t = document.querySelectorAll(me), n = 0, o = t.length; n < o; n++) {
          var r = t[n];
          r && "active" !== r.getAttribute(f) && (ge(e, r), r.parentNode && r.parentNode.removeChild(r));
        }
      }(this)), se(this, function () {
        return function (e) {
          for (var t = e.getTag(), n = t.length, o = "", r = function (n) {
              var r = function (e) {
                return pe.get(e);
              }(n);
              if (void 0 === r) return "continue";
              var s = e.names.get(r),
                i = t.getGroup(n);
              if (void 0 === s || 0 === i.length) return "continue";
              var a = "".concat(f, ".g").concat(n, '[id="').concat(r, '"]'),
                c = "";
              void 0 !== s && s.forEach(function (e) {
                e.length > 0 && (c += "".concat(e, ","));
              }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
            }, s = 0; s < n; s++) r(s);
          return o;
        }(r);
      });
    }
    return e.registerId = function (e) {
      return he(e);
    }, e.prototype.reconstructWithOptions = function (n, o) {
      return void 0 === o && (o = !0), new e(t(t({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function () {
      return this.tag || (this.tag = (e = function (e) {
        var t = e.useCSSOMInjection,
          n = e.target;
        return e.isServer ? new Ne(n) : t ? new be(n) : new Ee(n);
      }(this.options), new le(e)));
      var e;
    }, e.prototype.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function (e, t) {
      if (he(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, e.prototype.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(he(e), n);
    }, e.prototype.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function (e) {
      this.getTag().clearGroup(he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function () {
      this.tag = void 0;
    }, e;
  }(),
  Ie = /&/g,
  Ae = /^\s*\/\/.*$/gm;
function Oe(e, t) {
  return e.map(function (e) {
    return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function (e) {
      return "".concat(t, " ").concat(e);
    })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = Oe(e.children, t)), e;
  });
}
function De(e) {
  var t,
    n,
    o,
    r = void 0 === e ? N : e,
    s = r.options,
    i = void 0 === s ? N : s,
    a = r.plugins,
    c = void 0 === a ? E : a,
    l = function (e, o, r) {
      return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    },
    u = c.slice();
  u.push(function (e) {
    e.type === d.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace(Ie, n).replace(o, l));
  }), i.prefix && u.push(d.prefixer), u.push(d.stringify);
  var p = function (e, r, s, a) {
    void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
    var c = e.replace(Ae, ""),
      l = d.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
    i.namespace && (l = Oe(l, i.namespace));
    var p = [];
    return d.serialize(l, d.middleware(u.concat(d.rulesheet(function (e) {
      return p.push(e);
    })))), p;
  };
  return p.hash = c.length ? c.reduce(function (e, t) {
    return t.name || ce(15), k(e, t.name);
  }, 5381).toString() : "", p;
}
var Re = new Ce(),
  Te = De(),
  ke = o.createContext({
    shouldForwardProp: void 0,
    styleSheet: Re,
    stylis: Te
  }),
  je = ke.Consumer,
  xe = o.createContext(void 0);
function Ve() {
  return c(ke);
}
function Fe(e) {
  var t = s(e.stylisPlugins),
    n = t[0],
    r = t[1],
    c = Ve().styleSheet,
    l = i(function () {
      var t = c;
      return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
        target: e.target
      }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
        useCSSOMInjection: !1
      })), t;
    }, [e.disableCSSOMInjection, e.sheet, e.target, c]),
    u = i(function () {
      return De({
        options: {
          namespace: e.namespace,
          prefix: e.enableVendorPrefixes
        },
        plugins: n
      });
    }, [e.enableVendorPrefixes, e.namespace, n]);
  a(function () {
    p(n, e.stylisPlugins) || r(e.stylisPlugins);
  }, [e.stylisPlugins]);
  var d = i(function () {
    return {
      shouldForwardProp: e.shouldForwardProp,
      styleSheet: l,
      stylis: u
    };
  }, [e.shouldForwardProp, l, u]);
  return o.createElement(ke.Provider, {
    value: d
  }, o.createElement(xe.Provider, {
    value: u
  }, e.children));
}
var Me = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = Te);
        var o = n.name + t.hash;
        e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
      }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, se(this, function () {
        throw ce(12, String(n.name));
      });
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = Te), this.name + e.hash;
    }, e;
  }(),
  $e = function (e) {
    return e >= "A" && e <= "Z";
  };
function ze(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var o = e[n];
    if (1 === n && "-" === o && "-" === e[0]) return e;
    $e(o) ? t += "-" + o.toLowerCase() : t += o;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Be = function (e) {
    return null == e || !1 === e || "" === e;
  },
  Le = function (t) {
    var n,
      o,
      r = [];
    for (var s in t) {
      var i = t[s];
      t.hasOwnProperty(s) && !Be(i) && (Array.isArray(i) && i.isCss || Q(i) ? r.push("".concat(ze(s), ":"), i, ";") : oe(i) ? r.push.apply(r, e(e(["".concat(s, " {")], Le(i), !1), ["}"], !1)) : r.push("".concat(ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in h || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
  };
function Ge(e, t, n, o) {
  if (Be(e)) return [];
  if (ee(e)) return [".".concat(e.styledComponentId)];
  if (Q(e)) {
    if (!Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [e];
    var r = e(t);
    return "production" === process.env.NODE_ENV || "object" != typeof r || Array.isArray(r) || r instanceof Me || oe(r) || null === r || console.error("".concat(V(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Ge(r, t, n, o);
  }
  var s;
  return e instanceof Me ? n ? (e.inject(n, o), [e.getName(o)]) : [e] : oe(e) ? Le(e) : Array.isArray(e) ? Array.prototype.concat.apply(E, e.map(function (e) {
    return Ge(e, t, n, o);
  })) : [e.toString()];
}
function Ye(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (Q(n) && !ee(n)) return !1;
  }
  return !0;
}
var We = j("6.0.8"),
  qe = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n || n.isStatic) && Ye(e), this.componentId = t, this.baseHash = k(We, t), this.baseStyle = n, Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
      if (this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = te(o, this.staticRulesId);else {
          var r = ne(Ge(this.rules, e, t, n)),
            s = R(k(this.baseHash, r) >>> 0);
          if (!t.hasNameForId(this.componentId, s)) {
            var i = n(r, ".".concat(s), void 0, this.componentId);
            t.insertRules(this.componentId, s, i);
          }
          o = te(o, s), this.staticRulesId = s;
        }
      } else {
        for (var a = k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++) {
          var u = this.rules[l];
          if ("string" == typeof u) c += u, "production" !== process.env.NODE_ENV && (a = k(a, u));else if (u) {
            var p = ne(Ge(u, e, t, n));
            a = k(a, p + l), c += p;
          }
        }
        if (c) {
          var d = R(a >>> 0);
          t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = te(o, d);
        }
      }
      return o;
    }, e;
  }(),
  He = o.createContext(void 0),
  Ue = He.Consumer;
function Je() {
  var e = c(He);
  if (!e) throw ce(18);
  return e;
}
function Xe(e) {
  var n = o.useContext(He),
    r = i(function () {
      return function (e, n) {
        if (!e) throw ce(14);
        if (Q(e)) {
          var o = e(n);
          if ("production" !== process.env.NODE_ENV && (null === o || Array.isArray(o) || "object" != typeof o)) throw ce(7);
          return o;
        }
        if (Array.isArray(e) || "object" != typeof e) throw ce(8);
        return n ? t(t({}, n), e) : e;
      }(e.theme, n);
    }, [e.theme, n]);
  return e.children ? o.createElement(He.Provider, {
    value: r
  }, e.children) : null;
}
var Ze = {},
  Ke = new Set();
function Qe(e, r, s) {
  var i = ee(e),
    a = e,
    c = !F(e),
    p = r.attrs,
    d = void 0 === p ? E : p,
    h = r.componentId,
    f = void 0 === h ? function (e, t) {
      var n = "string" != typeof e ? "sc" : A(e);
      Ze[n] = (Ze[n] || 0) + 1;
      var o = "".concat(n, "-").concat(x("6.0.8" + n + Ze[n]));
      return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h,
    m = r.displayName,
    y = void 0 === m ? function (e) {
      return F(e) ? "styled.".concat(e) : "Styled(".concat(V(e), ")");
    }(e) : m,
    v = r.displayName && r.componentId ? "".concat(A(r.displayName), "-").concat(r.componentId) : r.componentId || f,
    g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d,
    S = r.shouldForwardProp;
  if (i && a.shouldForwardProp) {
    var w = a.shouldForwardProp;
    if (r.shouldForwardProp) {
      var C = r.shouldForwardProp;
      S = function (e, t) {
        return w(e, t) && C(e, t);
      };
    } else S = w;
  }
  var I = new qe(s, v, i ? a.componentStyle : void 0);
  function O(e, r) {
    return function (e, r, s) {
      var i = e.attrs,
        a = e.componentStyle,
        c = e.defaultProps,
        p = e.foldedComponentIds,
        d = e.styledComponentId,
        h = e.target,
        f = o.useContext(He),
        m = Ve(),
        y = e.shouldForwardProp || m.shouldForwardProp;
      "production" !== process.env.NODE_ENV && l(d);
      var v = function (e, n, o) {
          for (var r, s = t(t({}, n), {
              className: void 0,
              theme: o
            }), i = 0; i < e.length; i += 1) {
            var a = Q(r = e[i]) ? r(s) : r;
            for (var c in a) s[c] = "className" === c ? te(s[c], a[c]) : "style" === c ? t(t({}, s[c]), a[c]) : a[c];
          }
          return n.className && (s.className = te(s.className, n.className)), s;
        }(i, r, P(r, f, c) || N),
        g = v.as || h,
        S = {};
      for (var w in v) void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y || "development" !== process.env.NODE_ENV || n(w) || Ke.has(w) || !_.has(g) || (Ke.add(w), console.warn('styled-components: it looks like an unknown prop "'.concat(w, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var b = function (e, t) {
        var n = Ve(),
          o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
        return "production" !== process.env.NODE_ENV && l(o), o;
      }(a, v);
      "production" !== process.env.NODE_ENV && e.warnTooManyClasses && e.warnTooManyClasses(b);
      var E = te(p, d);
      return b && (E += " " + b), v.className && (E += " " + v.className), S[F(g) && !_.has(g) ? "class" : "className"] = E, S.ref = s, u(g, S);
    }(D, e, r);
  }
  "production" !== process.env.NODE_ENV && (O.displayName = y);
  var D = o.forwardRef(O);
  return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, "production" !== process.env.NODE_ENV && (D.displayName = y), D.foldedComponentIds = i ? te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
    get: function () {
      return this._foldedDefaultProps;
    },
    set: function (e) {
      this._foldedDefaultProps = i ? function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        for (var o = 0, r = t; o < r.length; o++) re(e, r[o], !0);
        return e;
      }({}, a.defaultProps, e) : e;
    }
  }), "production" !== process.env.NODE_ENV && (b(y, v), D.warnTooManyClasses = function (e, t) {
    var n = {},
      o = !1;
    return function (r) {
      if (!o && (n[r] = !0, Object.keys(n).length >= 200)) {
        var s = t ? ' with the id of "'.concat(t, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(e).concat(s, ".\n") + "Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), o = !0, n = {};
      }
    };
  }(y, v)), se(D, function () {
    return ".".concat(D.styledComponentId);
  }), c && K(D, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0
  }), D;
}
function et(e, t) {
  for (var n = [e[0]], o = 0, r = t.length; o < r; o += 1) n.push(t[o], e[o + 1]);
  return n;
}
var tt = function (e) {
  return Object.assign(e, {
    isCss: !0
  });
};
function nt(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
  if (Q(t) || oe(t)) {
    var r = t;
    return tt(Ge(et(E, e([r], n, !0))));
  }
  var s = t;
  return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? Ge(s) : tt(Ge(et(s, n)));
}
function ot(n, o, r) {
  if (void 0 === r && (r = N), !o) throw ce(1, o);
  var s = function (t) {
    for (var s = [], i = 1; i < arguments.length; i++) s[i - 1] = arguments[i];
    return n(o, r, nt.apply(void 0, e([t], s, !1)));
  };
  return s.attrs = function (e) {
    return ot(n, o, t(t({}, r), {
      attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
    }));
  }, s.withConfig = function (e) {
    return ot(n, o, t(t({}, r), e));
  }, s;
}
var rt = function (e) {
    return ot(Qe, e);
  },
  st = rt;
_.forEach(function (e) {
  st[e] = rt(e);
});
var it = function () {
  function e(e, t) {
    this.rules = e, this.componentId = t, this.isStatic = Ye(e), Ce.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function (e, t, n, o) {
    var r = o(ne(Ge(this.rules, t, n, o)), ""),
      s = this.componentId + e;
    n.insertRules(s, s, r);
  }, e.prototype.removeStyles = function (e, t) {
    t.clearRules(this.componentId + e);
  }, e.prototype.renderStyles = function (e, t, n, o) {
    e > 2 && Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
  }, e;
}();
function at(n) {
  for (var r = [], s = 1; s < arguments.length; s++) r[s - 1] = arguments[s];
  var i = nt.apply(void 0, e([n], r, !1)),
    a = "sc-global-".concat(x(JSON.stringify(i))),
    c = new it(i, a);
  "production" !== process.env.NODE_ENV && b(a);
  var l = function (e) {
    var t = Ve(),
      n = o.useContext(He),
      r = o.useRef(t.styleSheet.allocateGSInstance(a)).current;
    return "production" !== process.env.NODE_ENV && o.Children.count(e.children) && console.warn("The global style component ".concat(a, " was given child JSX. createGlobalStyle does not render children.")), "production" !== process.env.NODE_ENV && i.some(function (e) {
      return "string" == typeof e && -1 !== e.indexOf("@import");
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), o.useLayoutEffect(function () {
      if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function () {
        return c.removeStyles(r, t.styleSheet);
      };
    }, [r, e, t.styleSheet, n, t.stylis]), null;
  };
  function u(e, n, o, r, s) {
    if (c.isStatic) c.renderStyles(e, g, o, s);else {
      var i = t(t({}, n), {
        theme: P(n, r, l.defaultProps)
      });
      c.renderStyles(e, i, o, s);
    }
  }
  return o.memo(l);
}
function ct(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
  "production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var r = ne(nt.apply(void 0, e([t], n, !1))),
    s = x(r);
  return new Me(s, r);
}
function lt(e) {
  var n = o.forwardRef(function (n, r) {
    var s = P(n, o.useContext(He), e.defaultProps);
    return "production" !== process.env.NODE_ENV && void 0 === s && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'.concat(V(e), '"')), o.createElement(e, t({}, n, {
      theme: s,
      ref: r
    }));
  });
  return "production" !== process.env.NODE_ENV && (n.displayName = "WithTheme(".concat(V(e), ")")), K(n, e);
}
var ut = function () {
    function e() {
      var e = this;
      this._emitSheetCSS = function () {
        var t = e.instance.toString(),
          n = Se(),
          o = ne([n && 'nonce="'.concat(n, '"'), "".concat(f, '="true"'), "".concat("data-styled-version", '="').concat("6.0.8", '"')].filter(Boolean), " ");
        return "<style ".concat(o, ">").concat(t, "</style>");
      }, this.getStyleTags = function () {
        if (e.sealed) throw ce(2);
        return e._emitSheetCSS();
      }, this.getStyleElement = function () {
        var n;
        if (e.sealed) throw ce(2);
        var r = ((n = {})[f] = "", n["data-styled-version"] = "6.0.8", n.dangerouslySetInnerHTML = {
            __html: e.instance.toString()
          }, n),
          s = Se();
        return s && (r.nonce = s), [o.createElement("style", t({}, r, {
          key: "sc-0-0"
        }))];
      }, this.seal = function () {
        e.sealed = !0;
      }, this.instance = new Ce({
        isServer: !0
      }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function (e) {
      if (this.sealed) throw ce(2);
      return o.createElement(Fe, {
        sheet: this.instance
      }, e);
    }, e.prototype.interleaveWithNodeStream = function (e) {
      throw ce(3);
    }, e;
  }(),
  pt = {
    StyleSheet: Ce,
    mainSheet: Re
  };
"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");
var dt = "__sc-".concat(f, "__");
"production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window[dt] || (window[dt] = 0), 1 === window[dt] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window[dt] += 1);
export { ut as ServerStyleSheet, je as StyleSheetConsumer, ke as StyleSheetContext, Fe as StyleSheetManager, Ue as ThemeConsumer, He as ThemeContext, Xe as ThemeProvider, pt as __PRIVATE__, at as createGlobalStyle, nt as css, st as default, ee as isStyledComponent, ct as keyframes, st as styled, Je as useTheme, m as version, lt as withTheme };